import { getCurrentUser } from '@authentication/services/userServices';
import { useQuery } from '@tanstack/react-query';

export const useQueryCurrentUser = (enable: boolean) => {
  return useQuery({
    queryKey: ['user'],
    queryFn: getCurrentUser,
    enabled: enable,
  });
};
